//GET & POST recent thoughts 
// export const API_URL_THOUGHTS = "https://happy-thoughts-technigo.herokuapp.com/thoughts"
export const API_URL_THOUGHTS = "https://saras-happy-thought.herokuapp.com/thoughts"

//LIKE A THOUGHT
// export const API_URL_LIKE = (_id) =>`https://happy-thoughts-technigo.herokuapp.com/thoughts/${_id}/like`
export const API_URL_LIKE = (_id) =>`https://saras-happy-thought.herokuapp.com/thoughts/${_id}/likes`